import DatePicker from 'app/components/DatePicker';
import FilterToggle from './FilterToggle';
import FilterStack from './FilterStack';

import useFilter, {
  DATE,
  GREATER_THAN,
  LESS_THAN,
  EQUALS,
  NOT_EQUAL
} from 'app/hooks/useFilter';

// filter class (doesn't change)
const FILTER_CLASS = DATE;

// enabled filter types
const FILTER_TYPES = [
  EQUALS,
  GREATER_THAN,
  LESS_THAN,
  NOT_EQUAL
]

// default filter type for new filters in stack
const DEFAULT_FILTER_TYPE = FILTER_TYPES[0];

const DateFilterStack = props => {
  return (
    <FilterStack
      {...props}
      FilterComponent={DateFilter}
      filterClass={FILTER_CLASS}
      defaultFilterType={DEFAULT_FILTER_TYPE}
    />
  );
}

const DateFilter = props => {
  const valueFormatter = date => {
    if (date?.toDate) {
      // trim time to only pass date
      return date.toDate().toISOString().split('T')[0];
    }

    return null;
  }

  const {
    value,
    clearValue,
    onChange,
    filterType,
    setFilterType,
  } = useFilter({
    ...props,
    filterClass: FILTER_CLASS,
    filterType: DEFAULT_FILTER_TYPE,
    valueFormatter
  });

  const filterToggle = <FilterToggle filterType={filterType} filterTypes={FILTER_TYPES} setFilterType={setFilterType} />;

  const showClearIcon = true;
  const onClear = clearValue;

  let sx = {
    height: '100%'
  }
  if (props.sx) {
    sx = { ...sx, ...props.sx };
  }

  const inputProps = {
    startAdornment: filterToggle
  }
  
  return (
    <DatePicker
      variant="filled"
      size="small"
      sx={sx}
      onChange={onChange}
      showClearIcon={showClearIcon}
      onClear={onClear}
      InputProps={inputProps}
      value={value}
    />
  );
}

export default DateFilterStack;
